<template>
	<div class="page">
		<template v-if="group && posts">
			<v-card flat outlined class="wall-card">
				<group-background-picture />
				<v-card-text class="pt-0" style="margin-top: -90px; z-index: 2; position: relative;">
					<group-header v-model="view" :group="group" />
					<group-data v-if="view === 'base'" :group="group" />
					<group-settings
						class="mt-5"
						v-if="view === 'settings'"
						v-model="view"
						:group="group"
					/>
					<group-form-members v-else-if="view === 'members'" />
				</v-card-text>
			</v-card>
			<group-activities v-if="view === 'base' && postsVisibility" />
		</template>
		<v-skeleton-loader
			v-else
			type="card"
		></v-skeleton-loader>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GroupHeader from "@/components/group/GroupHeader";
import GroupActivities from "@/components/group/GroupActivities";
import GroupSettings from "@/components/group/GroupSettings";
import GroupData from "@/components/group/GroupData";
import GroupBackgroundPicture from "@/components/group/GroupBackgroundPicture";
import GroupFormMembers from "@/components/group/GroupFormMembers";
export default {
	name: "Group",
	components: {
		GroupHeader,
		GroupActivities,
		GroupSettings,
		GroupData,
		GroupBackgroundPicture,
		GroupFormMembers,
	},
	data() {
		return {
			view: 'base'
		}
	},
	computed: {
		...mapGetters({
			group: "groups/group",
			posts: 'groups/groupPosts',
		}),
		postsVisibility: function () {
			if (this.group.is_public || (!this.group.is_public && this.group.permissions.status === 'accepted'))
				return true
			else
				return false
		}
	},
	watch: {
		group: function (v) {
			if (!v) {
				this.$router.push({ name: 'Groups' })
			}
			// else {
			// 	this.view = 'base'
			// }
		}
	},
	created() {
		this.getGroup({ id: this.$route.params.id })
	},
	destroyed() {
		this.clearGroup()
	},
	methods: {
		...mapActions('groups', [
			"getGroup",
			"clearGroup",
		])
	}
}
</script>

